import { render, staticRenderFns } from "./EdDownload.vue?vue&type=template&id=2d80fd63&"
import script from "./EdDownload.vue?vue&type=script&lang=js&"
export * from "./EdDownload.vue?vue&type=script&lang=js&"
import style0 from "./EdDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports